<template>
  <v-dialog persistent max-width="600px" v-model="showModal">
    <v-card>
      <v-card-title>
        <span class="headline">Sponsor Tasks: </span>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <div v-for="(task, index) in sponsorsTaskList" :key="`sponsorTasks-${task.id}-${index}`">
            <v-checkbox
              :label="task.title"
              v-model="tasks"
              :value="task.id"
            ></v-checkbox>
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn color="error" dark large @click.stop="close">Cancel</v-btn>
        <v-btn color="success" dark large @click.stop="saveTasks">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'SponsorsFormModal',
    props: {
      taskFields: {
        type: Object,
        default: () => ({})
      },
      sponsorsTaskList: {
        type: Array
      }
    },
    data () {
      return {
        showModal: false,
        tasks: []
      }
    },
    methods: {
      ...mapActions(['updateSponsorTask']),
      async saveTasks () {
        if (this.taskFields.id) {
          await this.updateSponsorTask({id: this.taskFields.id, tasks: this.tasks})
          this.$emit('changeTaskStatus', {id: this.taskFields.id, tasks: this.tasks})
        }
        this.close()
      },
      close () {
        this.showModal = false
        this.id = null
      }
    },
    watch: {
      taskFields: {
        handler (val) {
          this.showModal = val.showTasks
          this.tasks = !!val.tasks ? val.tasks : []
        },
        deep: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Sponsors/SponsorsList/formTasks.vue